import { ButtonComp } from "../../../../components";
import FallbackImage from "../../../../components/Common/ImageWrapper";

export default function ListMessage({
  message,
  onClickEdit,
  onClickMakeDefault,
  btnText = "Make default",
  showDefaultBtn = true,
}) {
  return (
    <div className="bg-white px-4 p-4 rounded-4 mb-4 border shadow3 transition-all hover:shadow-md">
      <div className="d-flex gap-3 justify-content-between mb-3">
        <div 
          className="text-black1 flex-1 text-start leading-relaxed" 
          dangerouslySetInnerHTML={{ __html: message }}
          style={{ fontSize: '14px' }}
        />
        <div className="pointer p-2 hover:bg-light rounded-circle" onClick={onClickEdit} title="Edit message">
          <FallbackImage src="/Icon/edit1.svg" width="20px" height="20px" />
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        {showDefaultBtn ? (
          <ButtonComp
            btnText={btnText}
            btnClassName={"bg-primary1 text-white rounded-10 px-4 py-2 border-0 shadow-sm"}
            ButtonInlineStyle={{ fontSize: '12px' }}
            onClick={onClickMakeDefault}
          />
        ) : (
          <div className="d-flex align-items-center gap-2 text-success small fw-bold">
            <span className="dot bg-success" style={{width: '8px', height: '8px', borderRadius: '50%'}}></span>
            Current Default
          </div>
        )}
        <div className="pointer p-2 hover:bg-light rounded-circle" title="Delete message">
          <FallbackImage src="/Icon/delete.svg" width="20px" height="20px" />
        </div>
      </div>
    </div>
  );
}

